import { Component } from '@angular/core';

@Component({
    selector: 'app-default-layout',
    imports: [],
    templateUrl: './default-layout.component.html',
    styleUrl: './default-layout.component.css'
})
export class DefaultLayoutComponent {}
